import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import OwnerLogin from "@/pages/OwnerLogin";
import OwnerDashboard from "@/pages/OwnerDashboard";
import CreatorLogin from "@/pages/CreatorLogin";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import CreatorDashboard from "@/pages/CreatorDashboard";
import ReferralHandler from "@/pages/ReferralHandler";
import DiscordCallback from "@/pages/DiscordCallback";
import RequireAuth from "@/components/RequireAuth";

function App() {
  return (
    <div className="App font-sans text-white">
      <Toaster theme="dark" position="top-right" toastOptions={{ className: "font-mono !rounded-none !border !border-white/10 !bg-obsidian-surface" }} />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/r/:code" element={<ReferralHandler />} />
          <Route path="/auth/discord/callback" element={<DiscordCallback />} />
          <Route path="/owner/login" element={<OwnerLogin />} />
          <Route path="/owner/*" element={<RequireAuth kind="owner"><OwnerDashboard /></RequireAuth>} />
          <Route path="/creator/login" element={<CreatorLogin />} />
          <Route path="/creator/forgot-password" element={<ForgotPassword />} />
          <Route path="/creator/reset-password" element={<ResetPassword />} />
          <Route path="/creator/*" element={<RequireAuth kind="creator"><CreatorDashboard /></RequireAuth>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
